import { useCallback } from "react";
import { type ApiRequestOptions, apiRequest } from "@/lib/api-client";
import { useAuth } from "@/lib/auth-ui";

export function useApiClient() {
	const { getToken } = useAuth();

	return useCallback(
		async <TResponse>(
			path: string,
			options: Omit<ApiRequestOptions, "token"> = {},
		) => {
			const token = await getToken();
			return apiRequest<TResponse>(path, {
				...options,
				token: token ?? null,
			});
		},
		[getToken],
	);
}
